<template>
  <div class="bookwrap clearfix">
    <div class="bookinfo fl clearfix">
      <img
        class="fl bookimg"
        v-if="detail.iconUrl"
        v-lazy="imgURL + detail.iconUrl"
        alt=""
      />
      <img class="fl bookimg" v-else src="~img/default.png" alt="" />
      <div class="infotxt fl">
        <h2>{{ detail.name }}</h2>
        <p class="booktype">
          {{ detail.sort }} | {{ detail.words }}字 |
          {{ detail.visitorNum }}人浏览
        </p>
        <p class="tag">
          <span
            v-show="detail.tags != ''"
            v-for="(tag, index) in detail.tags"
            :key="index"
            >{{ tag }}</span
          >
        </p>
        <p class="detail">
          {{ detail.introduce }}
        </p>
        <div class="readbox">
          <button class="primary" @click="readChapter">
            {{ hisChapters != null ? "继续阅读" : "免费试读" }}
          </button>
          <button class="priplain" v-if="!bookisShelf" @click="useraddshelf">
            加入书架
          </button>
          <button
            class="priplain"
            v-if="isAuto"
            style="margin-right:0px"
            @click="cancleAuto"
          >
            取消订阅
          </button>
        </div>
      </div>
    </div>
    <div class="authorinfo fr">
      <div class="authorcenter">
        <div>
          <img
            v-if="authorDetail.iconUrlSmall"
            :src="imgURL + authorDetail.iconUrlSmall"
            alt=""
          />
          <img v-else src="~img/personal/default_head@2x.png" alt="" />
          <span>作者</span>
        </div>
        <p>{{ authorDetail.name }}</p>
      </div>
      <p class="elsehint" v-if="othersBook.length > 0">其他作品</p>
      <div class="au" v-if="othersBook.length > 0">
        <div class="authorBookBox">
          <ul
            class="clearfix"
            id="authorlist"
            :style="'width:' + 64 * othersBook.length + 'px'"
            ref="authorList"
          >
            <li
              class="fl"
              v-for="(book, index) in othersBook"
              :key="index"
              @click="goSeeDetail(book.id)"
            >
              <img v-if="book.iconUrl" v-lazy="imgURL + book.iconUrl" alt="" />
              <img v-else src="~img/default.png" alt="" />
              <p>{{ book.name }}</p>
            </li>
          </ul>
          <img
            class="leftbtn"
            @click="leftmove"
            v-if="othersBook.length > 3"
            src="~img/book/left.png"
            alt=""
          />
          <img
            class="rightbtn"
            v-if="othersBook.length > 3"
            @click="rightmove"
            src="~img/book/right.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="bookhint">{{ detail.finished ? "已完结" : "连载中" }}</div>
  </div>
</template>

<script>
export default {
  props: {
    detail: Object,
    authorDetail: Object,
    othersBook: Array,
    hisChapters: Object,
    bookisShelf: Boolean,
    isAuto: Boolean
  },
  data() {
    return {
      num: 0
    };
  },
  methods: {
    readChapter() {
      this.$emit("readbookId");
    },
    // 加入书架
    useraddshelf() {
      this.$emit("useraddshelf");
    },
    // 点击右边按钮
    rightmove() {
      if (this.num >= this.othersBook.length - 3) {
        this.num = 0;
      } else {
        this.num++;
      }

      $("#authorlist").animate(
        {
          left: `${-64 * this.num}px`
        },
        "0.5s"
      );
    },
    // 点击左边按钮
    leftmove() {
      if (this.num <= 0) {
        this.num = this.othersBook.length - 3;
      } else {
        this.num--;
      }
      $("#authorlist").animate(
        {
          left: `${-64 * this.num}px`
        },
        "0.5s"
      );
    },
    // 跳转作者其他书
    goSeeDetail(bookid) {
      const news = this.$router.resolve(`/bookdetail/${bookid}`);
      window.open(news.href, "_blank");
    },
    // 取消订阅
    cancleAuto() {
      this.$emit("cancleAuto");
    }
  },
  mounted() {}
};
</script>
<style lang="stylus" scoped>
.bookwrap
    width 1017px
    position relative
    background #fff
    margin 0px auto 10px
    box-sizing border-box
    padding 25px 20px 28px 24px
    .bookinfo
        margin-top 17px
        .bookimg
            width 198px
            height 289px
            background rgba(255, 255, 255, 1)
            box-shadow 0px 0px 6px 0px rgba(160, 160, 160, 0.5)
            margin-right 24px
        .infotxt
            width 485px
            overflow hidden
            h2
                font-weight 600
                color rgba(51, 51, 51, 1)
                font-size 30px
            .booktype
                color rgba(51, 51, 51, 1)
                margin 14px 0 22px
                font-size 14px
            .tag
                span
                    display inline-block
                    font-size 12px
                    font-weight 400
                    color rgba(198, 134, 28, 1)
                    padding 4px 10px
                    border-radius 14px
                    border 1px solid rgba(245, 166, 35, 1)
                    margin-right 12px
            .detail
                font-size 14px
                font-family PingFangSC
                font-weight 400
                color rgba(0, 0, 0, 1)
                line-height 25px
                height 75px
                margin 22px 0 28px
                overflow hidden
            .readbox
                .primary
                    width 150px
                    height 40px
                    background rgba(72, 162, 223, 1)
                    border-radius 4px
                    font-size 16px
                    font-weight 400
                    color rgba(255, 255, 255, 1)
                    border none
                    margin-right 15px
                .priplain
                    width 150px
                    height 40px
                    background rgba(255, 255, 255, 1)
                    border-radius 4px
                    border 1px solid rgba(72, 162, 223, 1)
                    font-size 16px
                    font-family PingFangSC
                    margin-right: 15px;
                    font-weight 400
                    color rgba(72, 162, 223, 1)
    .authorinfo
        width 220px
        height 304px
        background rgba(249, 249, 249, 1)
        box-sizing border-box
        padding 27px 0px
        color #333
        .authorcenter
            text-align center
            div
                position relative
                img
                    width 86px
                    height 86px
                    margin-bottom 6px
                    border-radius 50%
                span
                    position absolute
                    display block
                    width 29px
                    height 15px
                    background rgba(72, 162, 223, 1)
                    border-radius 2px
                    font-size 12px
                    color #fff
                    text-align center
                    line-height 15px
                    bottom 9px
                    left 50%
                    margin-left -14.5px
            p
                margin-bottom 28px
        .elsehint
            margin-left 10px
        .au
            position relative
            .leftbtn
                position absolute
                top 45px
                left 5px
                cursor pointer
            .rightbtn
                position absolute
                top 45px
                right 5px
                cursor pointer
            .authorBookBox
                width 176px
                overflow hidden
                margin-left 22px
                ul
                    margin-top 7px
                    position relative
                    li
                        margin-left 10px
                        font-size 12px
                        float left
                        width 52px
                        margin-bottom 10px
                        cursor pointer
                        &:first-child
                            margin-left 0px
                        img
                            width 52px
                            height 70px
                            box-shadow 0px 0px 6px 0px rgba(160, 160, 160, 0.5)
                        p
                            width 100%
                            overflow hidden
                            text-overflow ellipsis // 文本溢出显示省略号
                            white-space nowrap // 文本不会换行（单行文本溢出）
    .bookhint
        position absolute
        top 0
        left 0
        width 73px
        height 30px
        background rgba(72, 162, 223, 1)
        border-radius 0px 15px 15px 0px
        color #fff
        font-size 16px
        line-height 30px
        text-align center
</style>
